export type SiteHeaderVariant = "hero" | "standard"

interface HeaderRouteMatch {
  staticData: {
    header?: SiteHeaderVariant
  }
}

export function getRouteHeaderVariant(matches: readonly HeaderRouteMatch[]): SiteHeaderVariant {
  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const header = matches[index]?.staticData.header
    if (header) return header
  }

  return "standard"
}

export function getEffectiveHeaderVariant(
  routeVariant: SiteHeaderVariant,
  mobileOpen: boolean,
): SiteHeaderVariant {
  return routeVariant === "hero" && !mobileOpen ? "hero" : "standard"
}
